<template>
    <entity-editor entity="plot" :id="id" :new-entity="newPlot" @isDirtyChange="handleIsDirtyChange">
        <template v-slot:[`editor`]="{ doc }">
            <v-row>
                <v-col cols="12">
                    <v-text-field v-model="doc.name" label="Plot Name" :rules="[requiredRule]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <large-text-editor
                        v-model="doc.details"
                        label="Details"
                        :rules="[requiredRule]"
                    ></large-text-editor>
                </v-col>
            </v-row>
        </template>
    </entity-editor>
</template>
<script>
import editorMixin from '../../mixins/editorMixin'
import navGuardConfirmMixin from '../../mixins/navGuardConfirmMixin'
export default {
    name: 'PlotEditor',
    mixins: [navGuardConfirmMixin, editorMixin],
    props: {
        id: {
            type: [Number, String],
            required: false,
            validator: value => {
                return !!value
            },
        },
    },
    methods: {
        newPlot() {
            return {
                name: '',
                details: '',
                teamId: null,
            }
        },
    },
}
</script>
